import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import { Layout } from "antd";
import { useEffect, useRef, useState } from "react";
import MainHeader from "../components/Header/Header";
import { WebsiteFooter } from "pepsico-ds";
import { urlConstants } from "../constants/urlConstants";
import FloatingAIButton from "../components/Button/FloatingAIButton";

const AppLayout = ({ showWebsiteFooter }) => {
  console.log("In AppLayout");
  const location = useLocation();
  const isAiChatRoute =
    location.pathname === "/ai-assistant/market-intelligence" ||
    location.pathname === "/ai-assistant/market-intelligence-conversations" ||
    location.pathname === "/ai-assistant/knowledge-management" ||
    location.pathname === "/ai-assistant/knowledge-management-conversations";
  const isSpendAnalyticsAgent =
    location.pathname === "/spend-analytics-ai-agent" ||
    location.pathname === "/spend-analytics-ai-agent-conversations";
  const isAiLikeLayout = isAiChatRoute || isSpendAnalyticsAgent;
  const hideSidebar = location.pathname === "/login";
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle("ai-like-route", isSpendAnalyticsAgent);
    return () => {
      document.body.classList.remove("ai-like-route");
    };
  }, [isSpendAnalyticsAgent]);

  // const triggerRerender = () => {

  //   setRefreshKey(prev => prev + 1);
  // };

  return (
    <Layout
      ref={scrollContainerRef}
      className={`scroll-container${isAiLikeLayout ? " ai-assistant-layout" : ""}`}
    >
      {/* <MainHeader onTrigger={triggerRerender}/> */}
      <MainHeader />
      <div
        style={{
          display: "flex",
          background: isAiLikeLayout ? "#FFFFFF" : "#D7E5F8",
          ...(isAiLikeLayout
            ? {
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
              }
            : {}),
        }}
      >
        {!hideSidebar && <Sidebar />}
        {/* <Outlet key={refreshKey}/> */}
        <Outlet />
      </div>
      <FloatingAIButton />
      {showWebsiteFooter && (
        <>
          <WebsiteFooter
            // actionMenu={{

            //   onChange: function wRe(){},

            // }}
            className="custom-global-footer"
            copyRightText="© 2026 Procurement Hub. All rights reserved."
            footerActions={[
              {
                onClick: function wRe() {
                  window.open(
                    urlConstants.procurementIntakeForm,
                    "_blank",
                    "noopener",
                  );
                },
                text: "Intake Form",
                iconLeading: "support_agent",
              },
            ]}
            // footerMessage="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."

            showMenuTitles
            style={{ zIndex: "9" }}
            themeStyle="auto"
            type="simple"
          />
        </>
      )}
    </Layout>
  );
};

export default AppLayout;
